import React from "react";
import { Stack, styled, Typography } from "@mui/material";

const StyledStack = styled(Stack)(({ theme }) => ({
  boxSizing: "border-box",
  alignItems: "center",
  gap: theme.spacing(3),
  width: "100%",
  maxWidth: "818px",
  margin: "0 auto",

  "& .step-subheading": {
    //padding: theme.spacing(0, 8),
    maxPadding: theme.spacing(0, 8),
    textAlign: "center",
    fontSize: "19px",
    fontWeight: 500,
    lineHeight: "150%",
    letterSpacing: "0.15px",
    color: "#142A39",
  },
  "& .step-heading": {
    textAlign: "center",
    fontSize: "36px",
    fontWeight: 700,
    lineHeight: "100%",
    letterSpacing: "0.25px",
    color: "#182C3D",
  },
}));

const Page = ({ children, heading, subHeading, sx }) => {
  return (
    <StyledStack sx={sx}>
      {heading && <Typography className="step-heading">{heading}</Typography>}
      {subHeading && (
        <Typography className="step-subheading" variant="body1">
          {subHeading}
        </Typography>
      )}
      {children}
    </StyledStack>
  );
};

export default Page;
